/**
 * DocumentEmissionPage
 * Tela de emissão de documentos (PGR e demais laudos configurados no motor).
 *
 * @version 2026.1.0
 */

import React from 'react';
import { PageShell } from '../../components';
import { DocumentEmissionForm } from './components/DocumentEmissionForm';

const breadcrumbItems = [
  { label: 'Início', path: '/home' },
  { label: 'Segurança do Trabalho' },
  { label: 'Documentos Emitidos', path: '/documents/history' },
  { label: 'Emitir' },
];

export const DocumentEmissionPage: React.FC = () => (
  <PageShell
    breadcrumbs={breadcrumbItems}
    title="Emissão de Documentos"
    subtitle="Gere os documentos a partir dos dados já cadastrados na empresa"
  >
    <DocumentEmissionForm />
  </PageShell>
);

export default DocumentEmissionPage;
